import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import Link from 'next/link'

type Props = {
  id: number
  imgSrc: string
  title?: string
  size: 'small' | 'medium'
}

export const ProgramThumbnailCard = ({
  id,
  imgSrc,
  size,
}: Props): JSX.Element => {
  return (
    <Link href={`/programs/${id}`}>
      <a>
        <div
          className={`mb-[6.4vw] lg:mb-0 w-[74.4vw] h-[36.4vw] shadow-light lg:hover:opacity-50 ${
            size === 'small'
              ? 'lg:w-[19.8vw] lg:h-[9.7vw]'
              : 'lg:w-[24.3vw] lg:h-[11.9vw] mx-[1.2vw]'
          }`}
        >
          <ImageWraper
            src={imgSrc}
            // alt={`${objectiveName}の${
            //   title.includes('プログラム') ? title : `${title}プログラム`
            // }`}
            width={351}
            height={172}
          />
        </div>
      </a>
    </Link>
  )
}
